/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GitActionWorkflowHistoryItemResponseDto } from '../models/git-action-workflow-history-item-response-dto';
import { GitActionWorkflowRunDetailResponseDto } from '../models/git-action-workflow-run-detail-response-dto';
import { GitInfoWithRelations } from '../models/git-info-with-relations';

@Injectable({
  providedIn: 'root',
})
export class GitInfoControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation gitInfoControllerGetGitActionWorkflowHistory
   */
  static readonly GitInfoControllerGetGitActionWorkflowHistoryPath = '/git-action-workflow-history';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGitActionWorkflowHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGitActionWorkflowHistory$Response(params?: {
    limit?: number;
    status?: string;
  }): Observable<StrictHttpResponse<Array<GitActionWorkflowHistoryItemResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, GitInfoControllerService.GitInfoControllerGetGitActionWorkflowHistoryPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GitActionWorkflowHistoryItemResponseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGitActionWorkflowHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGitActionWorkflowHistory(params?: {
    limit?: number;
    status?: string;
  }): Observable<Array<GitActionWorkflowHistoryItemResponseDto>> {

    return this.getGitActionWorkflowHistory$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GitActionWorkflowHistoryItemResponseDto>>) => r.body as Array<GitActionWorkflowHistoryItemResponseDto>)
    );
  }

  /**
   * Path part for operation gitInfoControllerGetGitActionWorkflowRunByRunId
   */
  static readonly GitInfoControllerGetGitActionWorkflowRunByRunIdPath = '/git-action-workflow-run-details/{runId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGitActionWorkflowRunByRunId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGitActionWorkflowRunByRunId$Response(params: {
    runId: string;
  }): Observable<StrictHttpResponse<GitActionWorkflowRunDetailResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, GitInfoControllerService.GitInfoControllerGetGitActionWorkflowRunByRunIdPath, 'get');
    if (params) {
      rb.path('runId', params.runId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GitActionWorkflowRunDetailResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getGitActionWorkflowRunByRunId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGitActionWorkflowRunByRunId(params: {
    runId: string;
  }): Observable<GitActionWorkflowRunDetailResponseDto> {

    return this.getGitActionWorkflowRunByRunId$Response(params).pipe(
      map((r: StrictHttpResponse<GitActionWorkflowRunDetailResponseDto>) => r.body as GitActionWorkflowRunDetailResponseDto)
    );
  }

  /**
   * Path part for operation gitInfoControllerFindOne
   */
  static readonly GitInfoControllerFindOnePath = '/git-infos';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOne$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<GitInfoWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, GitInfoControllerService.GitInfoControllerFindOnePath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GitInfoWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOne(params?: {
    filter?: any;
  }): Observable<GitInfoWithRelations> {

    return this.findOne$Response(params).pipe(
      map((r: StrictHttpResponse<GitInfoWithRelations>) => r.body as GitInfoWithRelations)
    );
  }

}
